import actionTypes from "../actionTypes";

export const setSelectedShotclassDataAction = (data) => ({
  type: actionTypes.distributeTypes.SELECTED_SHOTCLASS_DATA,
  payload: data,
});
export const setSelectedSeriesDataAction = (data) => ({
  type: actionTypes.distributeTypes.SELECTED_SERIES_DATA,
  payload: data,
});
export const setSelectedCollectionDataAction = (data) => ({
  type: actionTypes.distributeTypes.SELECTED_COLLECTION_DATA,
  payload: data,
});
export const setShotclassDataAction = (data) => ({
  type: actionTypes.distributeTypes.SHOTCLASS_DATA,
  payload: data,
});
export const setSeriesDataAction = (data) => ({
  type: actionTypes.distributeTypes.SERIES_DATA,
  payload: data,
});
export const setCollectionDataAction = (data) => ({
  type: actionTypes.distributeTypes.COLLECTION_DATA,
  payload: data,
});
export const setClassAndCollectionByProgramIdAction = (data) => ({
  type: actionTypes.distributeTypes.CLASS_AND_COLLECTION_BY_PROGRAM_ID,
  payload: data,
});
export const setCertificateByProgramIdAction = (data) => ({
  type: actionTypes.distributeTypes.CERTIFICATE_BY_PROGRAM_ID,
  payload: data,
});
export const setAllClassNamesAction = (data) => ({
  type: actionTypes.distributeTypes.ALL_CLASS_NAMES,
  payload: data,
});
